import translateModule from "./r2TranslateModule"

export default translateModule.service("translateService", ["$translate", ($translate) => {
    return {
        /**
         * Retorna uma promessa que será resolvida quando o idioma for alterado.
         * @param language {string} novo idioma
         */
        changeLanguage(language) {
            window.localStorage.setItem("locale", language)
            return $translate.use(language)
        },
        /**
         * Retorna o código do idioma atual com a variante.
         * @returns {string}
         */
        getCurrentLanguage() {
            return window.localStorage.getItem("locale") || "pt-br"
        }
    }
}])